module.exports = __webpack_public_path__ + "fonts/opensans-semibold-webfont.08cc8f82.ttf";